import React from 'react';

export default ({ className, ...other }) => (

  <svg className={`icon w16 ${className || ''}`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
    <path id="arrow-right-solid" d="M6.378,38.655l.743-.763a.786.786,0,0,1,1.135,0l6.508,6.674a.836.836,0,0,1,0,1.164L8.256,52.408a.786.786,0,0,1-1.135,0l-.743-.763a.84.84,0,0,1,.013-1.178l4.034-3.943H.8A.812.812,0,0,1,0,45.7V44.6a.812.812,0,0,1,.8-.824h9.622L6.391,39.833A.834.834,0,0,1,6.378,38.655Z" transform="translate(0 -37.65)" />
  </svg>
);
